import React from 'react';
import './_empty-search.scss';
import './_empty-search.dark-mode.scss'
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ReactComponent as NoResult } from './noresult.svg';
import { ReactComponent as NoResultDarkMode } from './noresult-dark-mode.svg';
import { getSelectedSearchOption } from '../../../../helpers/getters';

const TableEmptyServices = ({ search, searchOption }) => {
  const { darkMode } = useSelector((state) => state.general);
  const option = getSelectedSearchOption(searchOption);
  return (
    <div className="service-table__empty-search">
      <div>
        <div className="service-table__empty-search-icon">
          {darkMode ? <NoResultDarkMode /> : <NoResult /> }
        </div>
        <div className="service-table__empty-search-description">
          {searchOption && option
            ? (
              <div>
                {option.name}
                {' '}
                "
                <b>{search}</b>
                " not found
              </div>
            ) : (
              <div>
                No results were found for "
                <b>{search}</b>
                "
              </div>
            )}
        </div>
      </div>
    </div>
  )
}

TableEmptyServices.propTypes = {
  search: PropTypes.string,
  searchOption: PropTypes.string,
}

export default TableEmptyServices;
